// extracted by mini-css-extract-plugin
module.exports = {"root":"Home_root__1S1pE","headerContainer":"Home_headerContainer__33KMr","header":"Home_header__2Jid7","gray":"Home_gray__1ddM4","first":"Home_first__2eViq"};